import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/store/authStore';
import { refreshRoleAffectedQueries } from './rosterRefresh';
import { subscribeRosterChanges } from './rosterEvents';

/** Keep other open editors, lists and graph tabs authoritative without
 * resetting forms. Focus also recovers missed events or another user's edits. */
export function useRoleRosterSync() {
  const client = useQueryClient();
  useEffect(() => {
    const workspace = () => useAuthStore.getState().currentWorkspace?.id;
    const refresh = (id: string) => {
      void refreshRoleAffectedQueries(client, import.meta.env.VITE_API_URL, id, workspace());
    };
    const unsubscribe = subscribeRosterChanges(workspace, refresh);
    const onFocus = () => {
      const id = workspace();
      if (id) refresh(id);
    };
    window.addEventListener('focus', onFocus);
    return () => {
      unsubscribe();
      window.removeEventListener('focus', onFocus);
    };
  }, [client]);
}
